module.exports = __webpack_public_path__ + "static/module-amazon-smile-473ff0b183a73aa003bdfb5cfbc48e03.jpg";